export default __webpack_public_path__ + "static/media/Post-Listing-Microsite-Listed-Blocks-6.990b1470.jpg";